// cap ass footer i dont own sht
import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} BoredGames. All rights reserved.</p>
      <ul className="footer-links">
        <li><Link to="https://discord.gg/Abf8dyUDN3">https://discord.gg/Abf8dyUDN3</Link></li>
        <li><Link to="/about">Another Link</Link></li>
      </ul>
    </footer>
  );
};

export default Footer;
